import { __, sprintf } from '@wordpress/i18n';
import { RawHTML } from '@wordpress/element';
import { TicketStatusLog } from '../type/Ticket';
import { dateI18n, getSettings } from '@wordpress/date';

function CloseLogItem( { log }: { log: TicketStatusLog } ) {
    const name = log?.changed_by_name
        ? log?.changed_by_name
        : __( 'No Name', 'dokan' );
    return (
        <div className="p-4 border-b border-[#EEEEEE] flex flex-col gap-4 text-neutral-400">
            <RawHTML>
                { /* eslint-disable-next-line @wordpress/valid-sprintf */ }
                { sprintf(
                    // eslint-disable-next-line @wordpress/i18n-translator-comments
                    __( '%1s %2sclosed%3s this conversation on %4s', 'dokan' ),
                    name,
                    '<b>',
                    '</b>',
                    sprintf(
                        // translators: %1$s: withdraw date, %2$s: withdraw time
                        __( '%1$s at %2$s', 'dokan-lite' ),
                        dateI18n(
                            getSettings().formats.date,
                            log?.date_created,
                            getSettings().timezone.string
                        ),
                        dateI18n(
                            getSettings().formats.time,
                            log?.date_created,
                            getSettings().timezone.string
                        )
                    )
                ) }
            </RawHTML>
        </div>
    );
}

export default CloseLogItem;
